import React, { useEffect, useState } from 'react'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'
import JointlyOwnedVehicleSummaryView from './JointlyOwnedVehicleSummaryView'
import { useSelector } from 'react-redux';

const JointlyOwnedVehicleSummary = ({ i18n }) => {
    const [isError, setIsError] = useState(false)

    const addressTypeChange = useSelector((state) => state.app.addressTypeChange);

    useEffect(() => {
        try {
            addToGoogleDataLayer('jointly-owned-vehicle-summary', 'Change of Address', i18n.language, addressTypeChange)
            window.scrollTo(0, 0)
        } catch (e) {
            console.log(e)
        }
    }, [i18n.language, addressTypeChange])

    return isError ? <Error /> : <JointlyOwnedVehicleSummaryView setIsError={setIsError} />
}

export default withTranslation('common')(JointlyOwnedVehicleSummary)
